import { useMutation, useQuery } from 'react-query';
import { RecruitmentCompaniesService } from '@api/RecruitmentCompaniesService';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
const useListRecruitmentCompanies = (
  [page_no, searchText, selectedStatus,selectedCompanySize,selectedHeadOfficeCity],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['recruitment-candidate-companies-list', page_no, searchText, selectedStatus,selectedCompanySize,selectedHeadOfficeCity],
    RecruitmentCompaniesService.listRecruitmentCompanies,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};
// Create
const useAddRecruitmentCompanies = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentCompaniesService.addRecruitmentCompanies, {
    onSuccess,
    onError
  });
};
// Details
const useViewRecruitmentCompanies = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('recruitment-candidate-companies-view', () => RecruitmentCompaniesService.viewRecruitmentCompanies(id), {
    onSuccess,
    onError
  });
};
// Details
const useShowRecruitmentCompanies = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('recruitment-candidate-companies-show', () => RecruitmentCompaniesService.showRecruitmentCompanies(id), {
    onSuccess,
    onError
  });
};
const useUpdateRecruitmentCompanies = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentCompaniesService.updateRecruitmentCompanies, {
    onSuccess,
    onError
  });
};
// Delete
const useDeleteRecruitmentCompanies = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentCompaniesService.deleteRecruitmentCompanies, {
    onSuccess,
    onError
  });
};
const useUpdateRecruitmentCompaniesStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentCompaniesService.changeStatusRecruitmentCompanies, {
    onSuccess,
    onError
  });
};

const useListRecruitmentCompaniesCities = (
  [],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['recruitment-candidate-companies-city-list'],
    RecruitmentCompaniesService.listRecruitmentCompaniesCity,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};

export {
    useListRecruitmentCompanies,
    useAddRecruitmentCompanies,
    useViewRecruitmentCompanies,
    useShowRecruitmentCompanies,
    useDeleteRecruitmentCompanies,
    useUpdateRecruitmentCompaniesStatus,
    useUpdateRecruitmentCompanies,
    useListRecruitmentCompaniesCities
};
